export default {
  authServiceUrl: 'https://id.1ketoan.com',
  authApiUrl: 'https://id.1ketoan.com/api',
  accApiUrl: 'https://api.1ketoan.com',
  fileServiceUrl: 'https://file.1ketoan.com',
  commentServiceUrl: 'https://comment.1ketoan.com',
  notificationServiceUrl: 'https://event.1ketoan.com',
  frontSiteUrl: 'https://1ketoan.com',
};



// WEBPACK FOOTER //
// ./src/configs/prod.js